import { create } from "zustand";
import { IDLE_TIMEOUT } from "../constants/Common";

const mapInfoStore = create((set, get) => ({
  map: {},  // Lưu trữ bản đồ của từng player
  timeouts: {}, // Lưu timeout của từng player để hủy nếu có cập nhật mới

  setMap: (playerId, newMap) => {
    set((state) => ({
      map: {
        ...state.map,
        [playerId]: newMap,
      },
    }));

    // Nếu đã có timeout, clear nó trước
    if (get().timeouts[playerId]) {
      clearTimeout(get().timeouts[playerId]);
    }

    // Đặt timeout để xóa playerId sau 15 giây nếu không có cập nhật mới
    const timeoutId = setTimeout(() => {
      set((state) => {
        const newMap = { ...state.map };
        delete newMap[playerId];
        return { map: newMap };
      });

      // Xóa timeout khỏi danh sách
      set((state) => {
        const newTimeouts = { ...state.timeouts };
        delete newTimeouts[playerId];
        return { timeouts: newTimeouts };
      });
    }, IDLE_TIMEOUT.CLEAR_MAP_INFO);

    // Cập nhật danh sách timeout
    set((state) => ({
      timeouts: {
        ...state.timeouts,
        [playerId]: timeoutId,
      },
    }));
  },
}));

export default mapInfoStore;
